import { Product } from "@/types/product";
import { createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";
import { fetchProducts } from "./async-thunk";
import { newCustomerCleanup } from "../actions";

interface ProductState extends EntityState<Product, Product["id"]> {
  isError: boolean;
  isLoading: boolean;
}

export const productAdapter = createEntityAdapter({
  selectId: (product: Product) => product.id,
});

const getInitialState = (): ProductState => ({
  ...productAdapter.getInitialState(),
  isError: false,
  isLoading: false,
});

const productSlice = createSlice({
  name: "product",
  initialState: getInitialState(),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchProducts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProducts.fulfilled, (state, { payload }) => {
      state.isError = false;
      state.isLoading = false;
      productAdapter.setAll(state, payload);
    });
    builder.addCase(fetchProducts.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
    builder.addCase(newCustomerCleanup, () => getInitialState());
  },
});

export default productSlice.reducer;
